import { api, getCurrentUser, SavedSearchDto } from '@creditsights/api-ui-web';
import { PROFILES_MODULE_V1_URI } from '../services.constants';

const savedSearchesUri = (userId: string) => `${PROFILES_MODULE_V1_URI}${userId}/searches`;

export const fetchSavedSearches = async (): Promise<SavedSearchDto[]> => {
  const { userId } = getCurrentUser();
  if (!userId) {
    throw new Error('Failed to get userId');
  }

  const { data } = await api.get<SavedSearchDto[]>(savedSearchesUri(userId));
  return data;
};

export const deleteSavedSearch = async (id: string): Promise<void> => {
  const { userId } = getCurrentUser();
  if (!userId) {
    await Promise.reject(new Error('Failed to get userId'));
    return;
  }
  await api.delete<void>(`${savedSearchesUri(userId)}/${id}`);
};

export const createSavedSearch = async (savedSearch: SavedSearchDto): Promise<SavedSearchDto> => {
  const { userId } = getCurrentUser();
  if (!userId) {
    return Promise.reject(new Error('Failed to get userId'));
  }
  const { data } = await api.post<SavedSearchDto>(savedSearchesUri(userId), savedSearch);
  return data;
};

export const updateSavedSearch = async (savedSearch: SavedSearchDto): Promise<SavedSearchDto> => {
  const { userId } = getCurrentUser();
  if (!userId) {
    return Promise.reject(new Error('Failed to get userId'));
  }
  const { data } = await api.put<SavedSearchDto>(`${savedSearchesUri(userId)}/${savedSearch.id}`, savedSearch);
  return data;
};
